<template>
  <div class="side-menu">
    <div class="logo-container">
      <img :src="logoUrl" class="logo-img" alt="System Logo" />
    </div>

    <el-menu
      :default-active="$route.path"
      :router="true"
      class="el-menu-vertical"
      text-color="#606266"
      active-text-color="#42b983"
      :unique-opened="true"
    >
      <el-menu-item v-if="hasPermission('Database')" index="/database">
        <i class="el-icon-s-home"></i>
        <span slot="title">数据库</span>
      </el-menu-item>

      <el-menu-item v-if="hasPermission('Biodiversity')" index="/biodiversity">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span slot="title">生物多样性</span>
        </template>
      </el-menu-item>

      <el-submenu
        v-if="
          hasAnyPermission([
            'Carbon',
            'BioList',
            'BioStats',
            'Production',
            'Concentration',
            'Culture',
            'Summary',
            'system_decision',
          ])
        "
        index="/system"
      >
        <template slot="title">
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">生态系统服务</span>
        </template>

        <el-menu-item v-if="hasPermission('Carbon')" index="/system/carbon"
          >碳储量</el-menu-item
        >
        <el-menu-item v-if="hasPermission('BioList')" index="/system/list"
          >土壤肥力</el-menu-item
        >
        <el-menu-item v-if="hasPermission('BioStats')" index="/system/stats"
          >水源涵养</el-menu-item
        >
        <el-menu-item
          v-if="hasPermission('Production')"
          index="/system/production"
          >生产能力</el-menu-item
        >
        <el-menu-item
          v-if="hasPermission('Concentration')"
          index="/system/concentration"
          >负氧离子浓度</el-menu-item
        >
        <el-menu-item v-if="hasPermission('Culture')" index="/system/culture"
          >文化服务</el-menu-item
        >
        <el-menu-item v-if="hasPermission('Summary')" index="/system/summary"
          >多模块汇总</el-menu-item
        >
        <el-menu-item
          v-if="hasPermission('system_decision')"
          index="/system/decision"
          >数据决策</el-menu-item
        >
      </el-submenu>

      <el-menu-item v-if="hasPermission('Ecology')" index="/ecology">
        <i class="el-icon-files"></i>
        <span slot="title">生态系统服务权衡与协同</span>
      </el-menu-item>

      <el-menu-item v-if="hasPermission('Knowledge')" index="/knowledge">
        <i class="el-icon-files"></i>
        <span slot="title">知识库</span>
      </el-menu-item>

      <el-menu-item v-if="hasPermission('AiQa')" index="/aiQa">
        <i class="el-icon-files"></i>
        <span slot="title">AI问答</span>
      </el-menu-item>

      <el-submenu
        v-if="hasAnyPermission(['Account', 'Role', 'Permission'])"
        index="/account"
      >
        <template slot="title">
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">权限管理</span>
        </template>
        <el-menu-item v-if="hasPermission('Account')" index="/permission/account"
          >账号管理</el-menu-item
        >
        <el-menu-item v-if="hasPermission('Role')" index="/permission/role"
          >角色管理</el-menu-item
        >
        <el-menu-item v-if="hasPermission('Permission')" index="/permission/list"
          >权限管理</el-menu-item
        >
      </el-submenu>

      <el-menu-item
        v-if="hasPermission('article_categories_manage')"
        index="/article-categories"
      >
        <i class="el-icon-folder-opened"></i>
        <span slot="title">分类管理</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { getUserinfo } from "@/api/user/index";

export default {
  name: "SideMenu",
  data() {
    return {
      logoUrl: require("@/assets/logo.png"),
      // 1. 修改初始化：优先从本地存储获取，如果没有才用空数组
      roles: this.getStoredRoles(),
    };
  },
  mounted() {
    this.getUserinfo();
    window.addEventListener("permissions-updated", this.getUserinfo);
  },
  beforeDestroy() {
    window.removeEventListener("permissions-updated", this.getUserinfo);
  },
  methods: {
    // 辅助方法：读取本地存储，防止 JSON.parse 报错
    getStoredRoles() {
      try {
        const stored = sessionStorage.getItem("USER_PERMISSIONS");
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        return [];
      }
    },

    getUserinfo() {
      getUserinfo({ _from: "side_menu" })
        .then((res) => {
          if (res.code == 200) {
            // 兼容多种返回结构：roles[*].permissions / data.permissions
            const rolePerms = Array.isArray(res.data && res.data.roles)
              ? res.data.roles.flatMap((role) =>
                  Array.isArray(role && role.permissions)
                    ? role.permissions
                    : []
                )
              : [];
            const directPerms =
              res.data && Array.isArray(res.data.permissions)
                ? res.data.permissions
                : [];

            const merged = [...rolePerms, ...directPerms];
            const uniqMap = new Map();
            merged.forEach((p) => {
              const key = String(p && p.slug ? p.slug : "")
                .trim()
                .toLowerCase();
              if (key) uniqMap.set(key, p);
            });
            const permissions = Array.from(uniqMap.values());

            // 更新内存和持久化缓存（即便为空也覆盖旧缓存，避免脏数据）
            this.roles = permissions;
            sessionStorage.setItem(
              "USER_PERMISSIONS",
              JSON.stringify(permissions)
            );
          }
        })
        .catch((err) => {
          console.error("获取用户信息失败", err);
          // 如果接口报错（比如Token失效），可能需要清空本地权限防止显示错误菜单
          // sessionStorage.removeItem("USER_PERMISSIONS");
        });
    },

    hasPermission(slug) {
      if (!this.roles || this.roles.length === 0) return false;
      const target = String(slug || "").trim().toLowerCase();
      return this.roles.some(
        (permission) =>
          String(permission && permission.slug ? permission.slug : "")
            .trim()
            .toLowerCase() === target
      );
    },

    hasAnyPermission(slugsSlugList) {
      if (!this.roles || this.roles.length === 0) return false;
      return slugsSlugList.some((slug) => this.hasPermission(slug));
    },
  },
};
</script>
<style scoped>
.side-menu {
  height: 100%;
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
  overflow-y: auto;
  width: 240px;
}

.logo-container {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f0f0;
  background-color: #f5f7fa;
}

.logo-img {
  max-width: 80%;
  max-height: 60px;
  object-fit: contain;
}

.el-menu {
  border-right: none;
}
.el-menu-item.is-active {
  background-color: #eafff5 !important;
  border-right: 3px solid #42b983;
}
.el-menu-item i {
  color: #909399;
}
.el-menu-item.is-active i {
  color: #42b983;
}
</style>
